function recaptcha4i() {
	var executeRecaptcha = function (siteKey, actionName, callback) {
		grecaptcha.execute(siteKey, { action: actionName })
	            .then(function (token) {
	                callback(token);
	            });
	};
	
	// Accessibility changes to the HTML generated by Google
	var logo = document.getElementsByClassName('grecaptcha-logo');
	if (logo.length > 0) {
		var logoIframe = logo[0].getElementsByTagName('iframe');
		if (logoIframe.length > 0) {
			// Adds title to iframe
			logoIframe[0].setAttribute('title', 'Google reCAPTCHA Logo');	
			// Hides iframe from screen readers
			logoIframe[0].setAttribute('hidden', 'true');
		}
	}
	
	// Adds label to reCAPTCHA response textarea
	var response = document.getElementById('g-recaptcha-response-100000');
	if (response) {
		response.setAttribute('aria-label', 'reCAPTCHA response');
	}
	
	// wire up any forms needing recaptcha
	var recaptchaForms = document.getElementsByClassName('recaptchaForm');
	for (var i = 0; i < recaptchaForms.length; i++)
	{
	    var rForm = recaptchaForms[i];
	    var rSiteKey = rForm.getElementsByClassName('recaptchaSiteKey')[0].value;
	    var rActionName = rForm.getElementsByClassName('recaptchaActionName')[0].value;
	    rForm.onsubmit = function (e) {
	        e.preventDefault();
	        executeRecaptcha(rSiteKey, rActionName, function(token) {
	        	rForm.getElementsByClassName('recaptchaToken')[0].value = token;
	        	rForm.submit();
	    	});
	    };
	}
}
(function(){
	// Get the key for the recaptcha script
	fetch('/header/recaptchasitekey', { method: 'POST', headers: { 'X-Requested-With': 'fetch' }}).then(function(response ) {
		return  (response.ok) ? response.json() : { 'siteKey': '' }; // response.json() returns a promise    		
	}).then(function(json) {
		if(!json.siteKey || json.siteKey.length < 1) return;
		var recapEl = document.createElement('script'); 
		recapEl.type = 'text/javascript'; 
		recapEl.async = true; 
		recapEl.src = 'https://www.google.com/recaptcha/api.js?render=' + json.siteKey + '&onload=recaptcha4i'; // onload bit invokes the code above after the JS finishes loading
		var capBod = document.getElementsByTagName('body')[0]; 
		capBod.appendChild(recapEl);
	});
})();